import { useAppData } from "#app/lib/data";
import { canEdit } from "#app/lib/utils/access-level";
import { usePermission } from "./use-permission";

// Creating a project takes BOTH halves: the create.items role and a workflow
// the viewer can create into (edit-or-better access). A user with the role but
// no accessible workflow has nowhere to put a project, so every create-project
// affordance — the module-menu popovers, the ⌥/Alt+P hotkey — hides rather
// than opening a dialog that cannot commit.
export function useCanCreateProject(): boolean {
  const { workflows } = useAppData();
  const canCreateItems = usePermission("create.items");
  return canCreateItems && workflows.some((w) => canEdit(w.viewerAccessLevel));
}
